// extracted by mini-css-extract-plugin
export default {"ship-container":"Ship_ship-container__-0PmZ","ship-count":"Ship_ship-count__ngnox","selected":"Ship_selected__DcM3Q","ship":"Ship_ship__wsVJz","warning":"Ship_warning__RYa95"};